<div class="d-flex flex-column min-vh-100">
    <!-- <app-header></app-header> -->
    <app-header-buscador></app-header-buscador>
    <div class="m-3">
        <h1>AVISO DE PRIVACIDAD</h1>
        <br>
        <div style="margin-bottom: 5px">
            <strong>GRUPO INMOBILIARIO XXII S.A. de C.V.</strong> empresa responsable y titular del sitio web
            <a
                style="cursor: text; color: #1A7DB6 !important; border-bottom: 0.1px solid #1A7DB6;">www.catalogoinmobiliario.mx</a>,
            con
            domicilio ubicado en la calle de Cordillera del Márquez número 845, Lomas Cuarta Sección, CP 78216, San Luis
            Potosí,
            S.L.P., es responsable de recabar sus datos personales, del uso que se le dé a los mismos y de su
            protección,
            según
            la Ley Federal de Protección de Datos Personales en Posesión de los Particulares y su reglamento.
        </div>

        <div style="margin-bottom: 5px">
            Su información personal será utilizada únicamente para que los servidores de este sitio, se puedan poner en
            contacto
            con usted, para la posible compra-venta o renta de algún bien inmueble de su propiedad o sobre el cual tenga
            autorización de arrendar.
        </div>

        <div style="margin-bottom: 5px">
            Para tal finalidad mantendremos una base de datos, la cual estará bajo el resguardo de RODRIGO ROMO MILLAN,
            quien
            fue designado por esta Sociedad como encargado del manejo de sus siguientes datos personales: Nombre,
            teléfono y
            correo electrónico. En cuanto al servicio que le proporcionaremos trataremos su información patrimonial y
            financiera, regulada en el Art. 8 de la mencionada ley.
        </div>

        <div style="margin-bottom: 5px">
            Usted tiene el derecho de acceder, rectificar y cancelar sus datos personales, así como de oponerse al
            tratamiento
            de los mismos o revocar el consentimiento que nos haya otorgado, mediante el envío de un correo electrónico
            dirigido
            a la siguiente dirección: <a
                style="cursor: text; color: #1A7DB6 !important; border-bottom: 0.1px solid #1A7DB6;">rodrigo@catalogoinmobiliario.mx</a>
            Dicha solicitud deberá expresar con claridad en qué
            consiste el derecho que se ejercita y el cambio preciso que desea realizar. Para la cual recibirá en menos
            de 48
            horas, en el mismo correo remitente o mediante llamado telefónico que proporcione para tal efecto, las
            indicaciones
            del proceso a seguir.

        </div>
        <div style="margin-bottom: 5px">
            Asimismo, le informamos que sus datos personales no serán transferidos, a menos que así lo disponga una ley,
            obligación contractual, y/u ordenamiento judicial en este caso se solicitara su consentimiento expreso.
        </div>

        Cualquier modificación a este aviso de privacidad podrá consultarla en nuestra página de internet

        <a
            style="cursor: text; color: #1A7DB6 !important; border-bottom: 0.1px solid #1A7DB6;">www.catalogoinmobiliario.mx.</a>
    </div>
    <app-footer class="mt-auto"></app-footer>
</div>